module.exports = __webpack_public_path__ + "static/media/mickey@2x.8db9dad9.png";